import React from 'react'
import './styles.scss'

interface Props {
  title: string
  description?: string | JSX.Element | null | undefined
  icon?: string
  datatestid: string
}

const SimpleCard = ({
  title = 'Title',
  description = 'Description',
  datatestid = 'simple-card'
}: Props): JSX.Element => {
  return (
    <div className='ui-simple-card' data-testid={`${datatestid}-card`}>
      <div className='ui-simple-card-body'>
        <p data-testid={`${datatestid}-title`}>{title}</p>
        <span data-testid={`${datatestid}-description`}>{description}</span>
      </div>
    </div>
  )
}

export default SimpleCard
